module.exports = __webpack_public_path__ + "9dede7aad700d9c044ae611eb369fa7d.svg";